const GenerateBundleModalTestIdsScope = {
  GENERATE_BUNDLE: 'generate-bundle',
};

export const GenerateBundleModalTestIds = {
  TABS: `${GenerateBundleModalTestIdsScope.GENERATE_BUNDLE}.tabs`,
};
